import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const FinalCTA = ({ config = {} }) => {
  const [ref, isVisible] = useScrollAnimation();
  
  const finalCtaTitle = config.finalCtaTitle || 'Únete al top 0.1% de creadoras';
  const finalCtaHighlight = config.finalCtaHighlight || 'Tu próximo capítulo comienza aquí. Trabajemos juntos para construir tu marca y maximizar tu potencial.';

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    window.open('https://api.whatsapp.com/send?phone=573011920219&text=Hola,%20quiero%20unirme%20a%20JG%20Models', '_blank');
  };

  return (
    <section ref={ref} className="py-24 bg-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#c8784e] rounded-full filter blur-3xl" />
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className={`max-w-4xl mx-auto text-center fade-in ${isVisible ? 'visible' : ''}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            {finalCtaTitle}
          </h2>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-12 font-light">
            {finalCtaHighlight}
          </p>

          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 bg-[#c8784e] text-black px-10 py-5 rounded-full font-semibold text-lg hover:bg-[#d89a6f] transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#c8784e]/50 cursor-pointer"
          >
            Postular Ahora
            <ArrowRight size={24} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;